import type { RouteProps } from '../../util';
import { DashboardLicense } from '../components/pages/dashboard/dashboard-license';


export const LicenseRoute = (_: RouteProps) => <DashboardLicense/>;